import PropTypes from "prop-types";

const AlertModal = ({ buttons, title, message }) => {
  return (
    <div className="AlertModal">
      {title && <h3>{title}</h3>}
      <p>{message}</p>
      <div className="buttons w-100 d-flex justify-content-end align-items-center">
        {buttons.map((button, index) => (
          <button
            key={index}
            className={`ms-2 btn ${button.classNames || ""}`}
            onClick={() => button.onClick(button.type || null)}
            disabled={button.disabled}
          >
            {button.label}
          </button>
        ))}
      </div>
    </div>
  );
};

AlertModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      classNames: PropTypes.string,
      type: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
};

export default AlertModal;
